module.exports = __webpack_public_path__ + "img/exercise_test-2.c39c3ae0.png";